import React, { useEffect } from 'react';
import {
  Box,
  constants,
  Center,
  DefaultPageTemplate,
  Title,
} from '@thecb/components';
import AlertBar from '../../components/alert-bar';
import { CloseoutForm } from './CloseoutForm';
import { useSelector } from 'react-redux';
import SharedAlertBar from '../../components/alert-bar/SharedAlertBar';

const Header = ({ alertBar, alertBarActions }) => {
  const { alerts: sharedAlerts } = useSelector((state) => state.shared);
  return (
    <Box width="100%" padding="16px 0">
      <Center maxWidth="55.429rem">
        {alertBar.alerts.length > 0 && (
          <Box padding="16px 0">
            <AlertBar {...alertBar} {...alertBarActions} />
          </Box>
        )}
        {sharedAlerts.length > 0 && (
          <Box padding="16px 0">
            <SharedAlertBar />
          </Box>
        )}
        <Title
          color={constants.colors.CHARADE_GREY}
          weight={constants.fontWeights.FONT_WEIGHT_BOLD}
        >
          Closeout
        </Title>
      </Center>
    </Box>
  );
};

const Closeout = ({
  alertBars,
  actions,
  forms,
  modals,
  submitCloseoutForm,
  fetchCurrentBatch,
  displayCartAlert,
}) => {
  const { order } = useSelector((state) => state.cart);
  useEffect(() => {
    fetchCurrentBatch();
  }, []);

  if (
    order &&
    order.order_items?.length > 0 &&
    !alertBars.closeoutAlertBars.alerts.length > 0
  ) {
    displayCartAlert();
  }

  const content = (
    <Box padding="0 0 2rem">
      <CloseoutForm
        modals={modals}
        forms={forms}
        {...actions.forms.closeoutForm}
        {...actions.modals.closeout}
        {...forms.closeoutForm}
        submitCloseoutForm={submitCloseoutForm}
      />
    </Box>
  );

  return (
    <DefaultPageTemplate
      maxWidth="55.429rem"
      header={
        <Header
          key="CloseoutHeader"
          alertBar={alertBars.closeoutAlertBars}
          alertBarActions={actions.alertBars.closeoutAlertBars}
        />
      }
      content={content}
      gutters="0"
    />
  );
};

export default Closeout;
